export interface TourV2RoomSelectionState {
  isInEditMode: boolean
  selectedPurchasableOptions: Map<App.Occupants, Tours.V2OfferPurchasableOption>
  activeOccupantsIndex: number
  isModalOpen: boolean
}

export const tourV2RoomSelectionInitialState: TourV2RoomSelectionState = {
  isInEditMode: false,
  selectedPurchasableOptions: new Map(),
  activeOccupantsIndex: 0,
  isModalOpen: false,
}
